import moment from 'moment';

export function getLastDaysNames(count) {
  const lastDayNames = [];
  for (let i = 0; i < count; i++) {
    lastDayNames.push(moment().subtract(i, 'days').format('dddd'));
  }
  return lastDayNames.reverse();
}
